import { render, staticRenderFns } from "./CallbackBlock.vue?vue&type=template&id=38c7f222&scoped=true&"
import script from "./CallbackBlock.vue?vue&type=script&lang=js&"
export * from "./CallbackBlock.vue?vue&type=script&lang=js&"
import style0 from "./CallbackBlock.vue?vue&type=style&index=0&id=38c7f222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c7f222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c7f222')) {
      api.createRecord('38c7f222', component.options)
    } else {
      api.reload('38c7f222', component.options)
    }
    module.hot.accept("./CallbackBlock.vue?vue&type=template&id=38c7f222&scoped=true&", function () {
      api.rerender('38c7f222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/CallbackBlock.vue"
export default component.exports